import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import { DataColumn } from "../controls/Data.default";
import { buildSearchQuery, comboboxValue, QueryFieldMapping } from "../code/search-query/query-mapper";
import { InputObject } from "../controls/default";

export interface TemplatesForm {
  readonly uid?: string;
  readonly rowVersion?: string;
  readonly name: string;
  readonly subject: string;
  readonly body: string;
  readonly version: InputObject;
  readonly notificationType: InputObject;
  readonly categoryName: InputObject;
}

export const templatesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Subject",
    key: "subject",
    width: 192,
    sort: true,
  },
  {
    title: "Body",
    key: "body",
    width: 320,
    sort: true,
    type: "editorbox",
  },
  {
    title: "Version",
    key: "version",
    width: 320,
    sort: true,
    type: "badge",
  },
  {
    title: "Notification Type",
    key: "notificationType",
    width: 320,
    sort: true,
  },
  {
    title: "Category Name",
    key: "categoryName",
    width: 220,
    sort: true,
  },
  {
    title: "Created On",
    key: "createdOn",
    width: 168,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
  {
    title: "Updated On",
    key: "updatedOn",
    width: 168,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
];

const templatesQueryMappings: QueryFieldMapping[] = [
  { formField: "name", operation: QueryOperation.Contains },
  { formField: "subject", operation: QueryOperation.Contains },
  { formField: "body", operation: QueryOperation.Contains },
  { formField: "version", operation: QueryOperation.Equal },
  { formField: "notificationType", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "categoryName", operation: QueryOperation.Contains, transform: (v: InputObject) => v.display },
];

export const mapTemplatesViewQuery = (values: TemplatesForm): SearchQuery =>
  buildSearchQuery(values, templatesQueryMappings);
